import { useCallback, useState } from "react";
import Base from "../base";
import Button from "../../button";
import Icon from "../../icon";

export default function FieldPassword({ children, ...props }) {
	const [show, setShow] = useState(false);
	const toggle = useCallback(() => setShow(v => !v));
	return <Base {...props} content={show ? 'text' : 'password'}>
		{!props.disabled && <Button tabIndex='-1' type='iconic' onClick={toggle}>
			<Icon name='eye' toggle={!show} color={show ? 'var(--accent)' : 'var(--placeholder)'} />
		</Button>}
		{children}
	</Base>
}